const uniqReducer = (dest: { id: any }[], obj: { id: any }) => {
  if (dest.findIndex(({ id }) => parseFloat(id) === parseFloat(obj.id)) < 0) {
    return dest.concat(obj);
  }
  return dest;
};

export const uniqById = (array?: { id: any }[]): any => {
  if (!array?.length) return [];

  return array.reduce(uniqReducer, []);
};
